import { DecimalPipe } from '@angular/common';
import { OrderAttributes } from '@albatrosdeveloper/ave-models-package';
import get from 'lodash-es/get';
import { ExportTaskProcessor } from 'app/layout/export-overlay';
import { formatDate, formatHour, getExtraStatusName, getSourceDocument, getNextDocument } from '../../order-list-components/exports/sales-orders-list.utils';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

export class SalesInvoiceListCommonExportProcessor extends ExportTaskProcessor {
  constructor(protected decimalPipe: DecimalPipe) {
    super();
  }

  protected transformForMainSection(item: OrderAttributes) {
    return {
      serial: `${get(item, 'serial', '-')}`,
      serialExternal: `${get(item, 'externalKeys.code', '-')}`,
      status: ExportTaskProcessor.types.ave.status(get(item, 'statusId', '-')),
      statusERP: ExportTaskProcessor.types.ave.statusERP(get(item, 'statusERP')),
      trip: get(item, 'trip.id', '??'),
      route: `${get(item, 'subRoute.externalKeys.code', '??')} ${get(item, 'subRoute.name', '??')}`,
      user: get(item, 'user.user_login.username', '??'),
      responsibleCode: get(item, 'responsibleBusinessPartner.externalKeys.code', '-'),
      responsible: `${get(item, 'responsibleBusinessPartner.name', '-')}`,
      clientCode: get(item, 'soldTo.externalKeys.code', '-'),
      client: `${get(item, 'soldTo.name', '-')}`,
      NIT: get(item, 'shipTo.NIT', ''),
      classCode: get(item, 'class.code', '-'),
      class: `${get(item, 'class.name', '-')}`,
      destinationCode: get(item, 'shipTo.externalKeys.code', '??'),
      destination: `${get(item, 'shipTo.name', '??')}`,
      address: [
        get(item, 'address.address', ''),
        get(item, 'address.postalCode', ''),
        get(item, 'address.contactName', ''),
        get(item, 'address.locationTwo.name', ''),
        get(item, 'address.locationThree.name', ''),
        get(item, 'address.locationOne.name', ''),
      ].filter((s) => s).join(' , '),
      expeditionCondition: `${get(item, 'expeditionCondition.externalKeys.code', '')} - ${get(item, 'expeditionCondition.name', '')}`,
      paymentConditionCode: get(item, 'paymentCondition.externalKeys.code', ''),
      paymentCondition: `${get(item, 'paymentCondition.name', '')}`,
      note: get(item, 'note', '-'),
      loadDateTime: formatDate(item.loadDateTime),
      deliveryDateTime: formatDate(item.deliveryDateTime),
      extraStatusERPGlobal: getExtraStatusName(item.extraStatusERP, 'GLOBAL'),
      extraStatusERPReject: getExtraStatusName(item.extraStatusERP, 'REJECT'),
      extraStatusERPDelivery: getExtraStatusName(item.extraStatusERP, 'DELIVERY'),
      extraStatusERPCredit: getExtraStatusName(item.extraStatusERP, 'CREDIT'),
      extraStatusERPInvoice: getExtraStatusName(item.extraStatusERP, 'INVOICE'),
      extraStatusERPUser: getExtraStatusName(item.extraStatusERP, 'USER'),
      creationDate:`${formatDate(item.creationDateTime, false)} `,
      creationHour: `${formatHour(item.creationDateTime.toString())}`,
      subtotal: this.decimalPipe.transform(get(item, 'subTotal', 0), '1.2-2'),
      totalSurcharges: this.decimalPipe.transform(get(item, 'totalSurcharges', 0), '1.2-2'),
      totalDiscounts: this.decimalPipe.transform(get(item, 'totalDiscounts', 0), '1.2-2'),
      totalTaxes: this.decimalPipe.transform(get(item, 'totalTaxes', 0), '1.2-2'),
      total: this.decimalPipe.transform(get(item, 'total', 0), '1.2-2'),
    };
  }

  protected transformForDetailsSection(item: OrderAttributes) {
    return get(item, 'detail', []).filter((detail) => detail.statusId !== StatusEnum.INACTIVE).map((detail) => ({
      serial: `${get(item, 'serial', '-')}`,
      serialCodeExt:`${get(item, 'externalKeys.code', '-')}`,
      sourceDocument: getSourceDocument(item),
      nextDocument: getNextDocument(item),
      trip: get(item, 'trip.id', '-'),
      materialCode: `${get(detail, 'material.externalKeys.code', get(detail, 'detail.material?.code', '-'))}`,
      material: ` ${get(detail, 'material.name', '-')}`,
      note: get(detail, 'note', '-'),
      //warehouse: `${get(detail, 'warehouse.externalKeys.code', '??')} - ${get(detail, 'warehouse.name', '??')}`,
      soldQuantity: `${get(detail, 'soldQuantity', '??')} (${get(detail, 'soldUnitOfMeasure.name', '-')})`,
      invoice: get(item, 'invoiceDocument.externalDocument', '-'),
      price: this.decimalPipe.transform(get(detail, 'unitPrice', 0), '1.2-2'),
      subtotal: this.decimalPipe.transform(get(detail, 'subTotal', 0), '1.2-2'),
      totalSurcharges: this.decimalPipe.transform(get(detail, 'totalSurcharges', 0), '1.2-2'),
      totalDiscounts: this.decimalPipe.transform(get(detail, 'totalDiscounts', 0), '1.2-2'),
      totalTaxes: this.decimalPipe.transform(get(detail, 'totalTaxes', 0), '1.2-2'),
      total: this.decimalPipe.transform(get(detail, 'total', 0), '1.2-2'),
    }));
  }
}
